import React, { CSSProperties, FC, PropsWithChildren, useState } from "react";
import styled from "styled-components";
import ExpandCollapse from "common/Animations/ExpandCollapse";
import Card from "common/Boxes/Card";
import CaretRightOutlined from "@ant-design/icons/CaretRightOutlined";

interface ExpandingCardProps {
  blockClick?: boolean;
  collapsibleContent?: JSX.Element;
  expanded?: boolean;
  defaultExpanded?: boolean;
  id?: string;
  style?: CSSProperties;
  className?: string;
  setExpanded?: (expanded: boolean) => void;
  showArrow?: boolean;
  arrowIcon?: JSX.Element;
  onLongPress?: () => void;
}

const ExpandingCard: FC<PropsWithChildren<ExpandingCardProps>> = ({
  children,
  blockClick,
  collapsibleContent,
  expanded,
  setExpanded,
  defaultExpanded,
  id,
  style,
  className,
  showArrow,
  arrowIcon,
  onLongPress,
}) => {
  const [_expanded, _setExpanded] = useState(!!defaultExpanded);
  const localIsExpanded = expanded ?? _expanded;
  const localSetExpanded = setExpanded ?? _setExpanded;

  const toggleExpanded = () => {
    localSetExpanded(!localIsExpanded);
  };

  return (
    <Wrapper
      id={id}
      style={style}
      className={className}
      onClick={blockClick ? undefined : toggleExpanded}
      onLongPress={onLongPress}
    >
      <div style={{ position: "relative" }}>
        {children}
        {showArrow && (arrowIcon ?? <Arrow $expanded={expanded} />)}
      </div>
      {collapsibleContent && (
        <ExpandCollapse expanded={localIsExpanded} style={{ display: "grid" }}>
          <ExpandingContentWrapper>
            {collapsibleContent}
          </ExpandingContentWrapper>
        </ExpandCollapse>
      )}
    </Wrapper>
  );
};

export default ExpandingCard;

const Wrapper = styled(Card)`
  position: relative;
`;
const ExpandingContentWrapper = styled.div`
  margin-top: 16px;
  padding-top: 12px;
  border-top: ${(p) => p.theme.borders.lightest};
`;
const Arrow = styled(CaretRightOutlined)<{ $expanded?: boolean }>`
  position: absolute;
  color: ${(p) => p.theme.colors.mediumGrey};
  top: 50%;
  transform: translateY(-50%) rotate(${(p) => (p.$expanded ? 90 : 0)}deg);
  right: 0;
  transition: transform 0.35s;
`;
